// Mirror of farm-data-mapper.ts `isBuildingVacant`
// (`docs-engine/lambdas/docs-renderer/farm-data-mapper.ts`). Vacancy
// markers land on different fields depending on risk type:
//   - Dwelling risks (FO1/FO2/FO3/FO4): `building.residenceUsage`
//     stores 'vacant' or the shorthand 'V' (#30855).
//   - FO6Structures: `building.residenceType` stores 'vacant' (no
//     `residenceUsage` field at all).
// The dec mapper accepts every combination so the FMI 14 trigger,
// `isVacant` flag, and rendered "Residence Type/Usage" line work for
// both shapes. Staff-fe display flags previously only checked
// `residenceUsage === 'V'`, so a real offer with the FO6Structures
// shape would show as vacant on the dec but not in staff-fe.
// (#30735 audit alignment.)
//
// 'V' on `residenceType` is accepted defensively to mirror the
// mapper's tolerance — the public lookup uses 'vacant' (lowercase
// full word), but accepting both shorthands keeps drift-tolerance
// consistent with the existing usage check.

export const isBuildingVacant = (building) => {
  const usage = building?.residenceUsage;
  const type = building?.residenceType;
  if (usage === 'vacant' || usage === 'V') {
    return true;
  }
  if (type === 'vacant' || type === 'V') {
    return true;
  }
  return false;
};
